import React from 'react';

function CartTotalTemplate ({ modelAttributes, helpers }) {

	const { continueShoppingUrl, isCustomerService, qty } = helpers;

	return (
		<>
			<div className="cartHeader">
				{!isCustomerService && (
					<div className="cartHeader__items">
						<strong className="cartHeader__cart">Your Cart</strong>
						{' '}
						<span className="cartHeader__qty">
(
							{qty}
)
						</span>
					</div>
				)}
				<div>
					{!isCustomerService && (
						<a href={continueShoppingUrl} className="continueShopping">
							Continue Shopping
						</a>
					)}
				</div>
			</div>
		</>
	);

}

export default CartTotalTemplate;
